<template>
    <div class="surveys-container">
        <h1>Layouts</h1>
        <div class="search-container">
            <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
            <AdaButton title="NEUES LAYOUT" type="createButton" to="/layout/create"
                       icon="icon-add"></AdaButton>
        </div>
        <AdaDatatable style="width: 100%" :columns="columns" :data="rows" :show-pagination="true"
                      :search-value="searchValue" :transformers="transformers"
                      :size-of-page="10" @rowClicked="cellClicked"></AdaDatatable>
        <Dialog v-if="layoutToDelete" :show-close-button="true" :show="showDeleteDialog"
                :has-backdrop="true"
                @close="showDeleteDialog = false">
            <div class="delete-container">
                <h2>Layout löschen</h2>
                <div style="margin-bottom: 30px">
                    Soll das Layout: <span style="font-weight: bold">{{this.layoutToDelete.site}}</span>
                    wirklich
                    gelöscht werden?
                </div>
                <AdaButton class="btn-delete" @click="deleteLayout(layoutToDelete.id)" title="LÖSCHEN" type="createButton"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>

    import AdaDatatable from "../components/table/AdaDatatable";
    import {RepositoryFactory} from "../scripts/RepositoryFactory";
    import InputSearch from "../components/InputSearch";
    import AdaButton from "../components/AdaButton";
    import Dialog from "../components/Dialog";

    const LayoutRepository = RepositoryFactory.get('layouts');

    export default {
        name: "Layouts",
        components: {
            AdaDatatable,
            InputSearch,
            AdaButton,
            Dialog
        },
        data: function () {
            return {
                layoutToDelete: null,
                showDeleteDialog: false,
                searchValue: '',
                columns: [
                    {
                        viewName: 'ID',
                        propName: 'id',
                        sortable: true,
                    },
                    {
                        viewName: 'Seite',
                        propName: 'site',
                        sortable: true
                    },
                    {
                        viewName: 'Aktionen',
                        propName: 'actions'
                    }
                ],
                rows: [],
                transformers: [
                    {
                        propName: 'actions',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'edit':
                                        res += '<span style="cursor: pointer" data-type="edit" class="margin-right hover-highlight icon-edit"></span>';
                                        break;
                                    case 'delete':
                                        res += '<span style="cursor: pointer" data-type="delete" class="margin-right hover-highlight icon-delete"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    }
                ]
            }
        },
        computed: {},
        methods: {
            async getLayouts() {
                const {data} = await LayoutRepository.getAll();
                for (let i = 0; i < data.length; i++) {
                    data[i].actions = ['edit', 'delete'];
                }
                this.rows = data;
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.$router.push({name: 'editlayout', params: {id: data.row.id}});
                        break;
                    case 'delete':
                        this.layoutToDelete = data.row;
                        this.showDeleteDialog = true;
                        break;
                }
            },
            async deleteLayout(layoutId) {
                await LayoutRepository.deleteLayout(layoutId);
                this.showDeleteDialog = false;
                await this.getLayouts();
            }
        },
        mounted() {
            this.getLayouts();
        }
    }
</script>
<style lang="scss" scoped>

    .surveys-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }

    .search-container {
        width: 100%;
        background-color: white;
        height: 50px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 12px;
    }

</style>